
import React, { useEffect, useState } from "react";
import useAdsFilterPanel from "./useAdsFilterpanel";
import { formatLabel } from "./FilterChip";

const SAMPLE_BRANDS = [
  "Brand A", "Brand B", "Brand C", "Brand D",
  "Brand E", "Brand F", "Brand G", "Brand H"
];

function Section({ title, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="filter-section">
      <div className="section-head" onClick={() => setOpen(o => !o)}>
        <span className="section-label">{title}</span>
        <span style={{
          fontSize: 10,
          color: "var(--muted)",
          transition: "transform .2s",
          display: "inline-block",
          transform: open ? "rotate(0deg)" : "rotate(-90deg)"
        }}>
          ▼
        </span>
      </div>

      {open && <div>{children}</div>}
    </div>
  );
}

function CheckRow({ id, label, checked, onChange }) {
  return (
    <label className="checkbox-row" htmlFor={id}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        className="checkbox-input"
      />
      <span className="checkbox-label">{label}</span>
    </label>
  );
}


function DualRangeSlider({
  min,
  max,
  step = 1,
  minVal,
  maxVal,
  onChange,
  id
}) {


  const pLo = ((minVal - min) / (max - min)) * 100;
  const pHi = ((maxVal - min) / (max - min)) * 100;

  // SLIDER MIN
  const handleMinSlider = (e) => {
    const value = Number(e.target.value);

    if (value >= maxVal) return;

    onChange(value, maxVal);
  };

  // SLIDER MAX
  const handleMaxSlider = (e) => {
    const value = Number(e.target.value);

    if (value <= minVal) return;

    onChange(minVal, value);
  };

  // INPUT MIN
  const handleMinInput = (e) => {
    let value = e.target.value;

    if (value === "") {
      onChange("", maxVal);
      return;
    }

    value = Number(value);

    if (value < min) value = min;

    if (value >= maxVal) {
      value = maxVal - step;
    }

    onChange(value, maxVal);
  };

  // INPUT MAX
  const handleMaxInput = (e) => {
    let value = e.target.value;

    if (value === "") {
      onChange(minVal, "");
      return;
    }

    value = Number(value);

    if (value > max) value = max;

    if (value <= minVal) {
      value = minVal + step;
    }

    onChange(minVal, value);
  };

  return (
    <div>

      <div className="range-input-box">

        {/* MIN INPUT */}
        <div className="rupee-input">
          {id !== 'clicks' && (
            <span className="rupee-symbol">₹</span>
          )}
          <input
            type="number"
            value={minVal === "" ? "" : minVal}
            min={min}
            max={maxVal}
            onChange={handleMinInput}
            onKeyDown={(e) => {
              if (e.key === "-" || e.key === "e") {
                e.preventDefault();
              }
            }}
            className="range-number-input"
          />
        </div>

        <span className="range-separator">-</span>

        {/* MAX INPUT */}
        <div className="rupee-input">
          {id !== 'clicks' && (
            <span className="rupee-symbol">₹</span>
          )}

          <input
            type="number"
            value={maxVal === "" ? "" : maxVal}
            min={minVal}
            max={max}
            onChange={handleMaxInput}
            onKeyDown={(e) => {
              if (e.key === "-" || e.key === "e") {
                e.preventDefault();
              }
            }}
            className="range-number-input"
          />
        </div>

      </div>

      <div className="dual-range">

        <div className="range-track" />

        <div
          className="range-fill"
          style={{
            left: `${pLo}%`,
            width: `${pHi - pLo}%`
          }}
        />

        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={minVal || min}
          onChange={handleMinSlider}
          className="range-input"
        />

        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={maxVal || max}
          onChange={handleMaxSlider}
          className="range-input"
        />

      </div>

    </div>
  );
}


const formatINR = (v) => "₹" + v.toLocaleString("en-IN");
const formatNum = (v) => v.toLocaleString("en-IN");

export default function AdsFilterPanel({ brands = SAMPLE_BRANDS, onApply, appliedFilters, onClear, apiData }) {

  const [adsTypes, setAdsTypes] = useState({});
  const [campaign, setCampaign] = useState([]);
  const [brandSearch, setBrandSearch] = useState("");
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [spend, setSpend] = useState([0, 50000]);
  const [clicks, setClicks] = useState([0, 10000]);
  const [sales, setSales] = useState([0, 500000]);
  const [searchTerm, setSearchTerm] = useState("");
  const [matchTypes, setMatchTypes] = useState({});
  const [showAllMatch, setShowAllMatch] = useState(false);
  const [showAllBrandSearch, setshowAllBrandSearch] = useState(false);
  const [rangeLimits, setRangeLimits] = useState({
    spend: { min: 0, max: 50000 },
    clicks: { min: 0, max: 10000 },
    sales: { min: 0, max: 500000 }
  });

  useEffect(() => {

    if (!apiData?.ranges) return;

    // const ranges = apiData.ranges;
    const spendMin = apiData?.spend?.min ?? 0;
    const spendMax = apiData?.spend?.max ?? 50000;
    const clicksMin = apiData?.clicks?.min ?? 0;
    const clicksMax = apiData?.clicks?.max ?? 10000;
    const salesMin = apiData?.sales?.min ?? 0;
    const salesMax = apiData?.sales?.max ?? 500000;


    setRangeLimits({
      spend: { min: spendMin, max: spendMax },
      clicks: { min: clicksMin, max: clicksMax },
      sales: { min: salesMin, max: salesMax }
    });

    // update slider values
    setSpend([spendMin, spendMax]);
    setClicks([clicksMin, clicksMax]);
    setSales([salesMin, salesMax]);

  }, [apiData]);



  const toggleAdsType = (key) => {
    setAdsTypes(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const toggleCampaign = (v) =>
    setCampaign(p =>
      p.includes(v) ? p.filter(x => x !== v) : [...p, v]
    );

  const toggleBrand = (b) =>
    setSelectedBrands(p =>
      p.includes(b) ? p.filter(x => x !== b) : [...p, b]
    );

  const toggleMatchType = (m) =>
    setMatchTypes(p => ({ ...p, [m]: !p[m] }));

  const clearAll = () => {
    setAdsTypes({});
    setCampaign([]);
    setBrandSearch("");
    setSelectedBrands([]);
    setSpend([0, 50000]);
    setClicks([0, 10000]);
    setSales([0, 500000]);
    setSearchTerm("");
    setMatchTypes({});
    onClear?.();
  };

  useEffect(() => {
    if (!appliedFilters || Object.keys(appliedFilters).length === 0) return;

    //  Ads Types
    const adsObj = {};
    toArray(appliedFilters.ads_type)?.forEach((t) => {
      adsObj[t] = true;
    });
    setAdsTypes(adsObj);

    //  Campaign (status)
    setCampaign(toArray(appliedFilters?.status));

    //  Match Types
    const matchObj = {};
    toArray(appliedFilters.matchTypes)?.forEach((m) => {
      matchObj[m] = true;
    });
    setMatchTypes(matchObj);

    //  Brands
    setSelectedBrands(toArray(appliedFilters?.brand));

    //  Search
    setSearchTerm(appliedFilters?.search_term || "");

  }, [appliedFilters]);


  const applyFilters = () => {

    const filters = {
      ads_type: Object.entries(adsTypes)
        .filter(([_, v]) => v)
        .map(([k]) => k),

      status: campaign,
      brand: selectedBrands,
      spend,
      clicks,
      sales,
      searchTerm,

      matchTypes: Object.entries(matchTypes)
        .filter(([_, v]) => v)
        .map(([k]) => k)
    };

    const closeBtn = document.querySelector('.offcanvas-campaign .btn-close');
    if (closeBtn) closeBtn.click();

    onApply?.(filters);
  };

  const filteredBrands = (apiData?.brands || [])
    .filter(b =>
      b.toLowerCase().includes(brandSearch.toLowerCase())
    );

  const visibleBrands = showAllBrandSearch
    ? filteredBrands
    : filteredBrands.slice(0, 4);

  const matchTypeList = apiData?.match_type || [];

  const visibleMatchTypes = showAllMatch
    ? matchTypeList
    : matchTypeList.slice(0, 4);


  const toArray = (value) => {
    if (value === null || value === undefined || value === "") return [];

    if (Array.isArray(value)) return value;

    if (value === "undefined" || value === "null") return [];

    // comma separated string handle
    if (typeof value === "string" && value.includes(",")) {
      return value.split(",").filter(Boolean);
    }

    return [value];
  };

  return (
    <div className="filter-panel">

      <Section title="ADS TYPE">
        {apiData?.ads_type?.map(([label, value]) => (
          <CheckRow
            key={value}
            id={`at-${value}`}
            label={label}
            checked={!!adsTypes[value]}
            onChange={() => toggleAdsType(value)}
          />
        ))}
      </Section>

      <Section title="CAMPAIGN">
        {apiData?.campaign_status?.map(v => (
          <CheckRow
            key={v}
            id={`cp-${v}`}
            label={v}
            checked={campaign.includes(v)}
            onChange={() => toggleCampaign(v)}
          />
        ))}
      </Section>

      {/* Brand (Seller) */}
      <Section title="BRAND (SELLER)">

        <div style={{ marginTop: 8 }}>
          <div className="dt-search">
            <input
              type="search"
              className="form-control form-control-sm"
              style={{ paddingLeft: "29px" }}
              id="dt-search-26"
              placeholder="Search brand / seller…"
              aria-controls="CampagainName"
              value={brandSearch}
              onChange={(e) => setBrandSearch(e.target.value)}
            />
            <label htmlFor="dt-search-26"></label>
          </div>
          <div style={{ maxHeight: 160, overflowY: "auto" }}>
            {visibleBrands.map((b) => (
              <CheckRow key={b} id={`br-${b}`} label={b} checked={selectedBrands.includes(b)} onChange={() => toggleBrand(b)} />
            ))}
            {filteredBrands.length === 0 && <p style={{ fontSize: 12, color: "var(--muted)", padding: "4px 0" }}>No results</p>}
          </div>
          {filteredBrands.length > 4 && (
            <button className={"show-more-btn"} onClick={() => setshowAllBrandSearch((p) => !p)}>
              {showAllBrandSearch ? "– less" : `+ ${SAMPLE_BRANDS.length - 4} more`}
            </button>
          )}
        </div>
        {/* )} */}
      </Section>

      <Section title="SPEND RANGE">
        <DualRangeSlider
          id="spend"
          min={rangeLimits.spend.min}
          max={rangeLimits.spend.max}
          minVal={spend[0]}
          maxVal={spend[1]}
          onChange={(lo, hi) => setSpend([lo, hi])} />
      </Section>

      <Section title="CLICK RANGE">
        <DualRangeSlider
          id="clicks"
          min={rangeLimits.clicks.min}
          max={rangeLimits.clicks.max}
          minVal={clicks[0]}
          maxVal={clicks[1]}
          onChange={(lo, hi) => setClicks([lo, hi])} />

      </Section>

      <Section title="SALES RANGE">
        <DualRangeSlider
          id="sales"
          min={rangeLimits.sales.min}
          max={rangeLimits.sales.max}
          minVal={sales[0]}
          maxVal={sales[1]}
          onChange={(lo, hi) => setSales([lo, hi])} />

      </Section>

      <Section title="SEARCH TERM">
        <div className="dt-search">
          <input
            type="search"
            className="form-control form-control-sm"
            style={{ paddingLeft: "29px" }}
            id="dt-search-27"
            placeholder="Enter search term…"
            aria-controls="CampaignName"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <label htmlFor="dt-search-27"></label>
        </div>
      </Section>

      <Section title="MATCH TYPE">
        {visibleMatchTypes.map(m => (
          <CheckRow
            key={m}
            id={`mt-${m}`}
            label={formatLabel(m)}
            checked={!!matchTypes[m]}
            onChange={() => toggleMatchType(m)}
          />
        ))}

        {matchTypeList.length > 4 && (
          <button
            className="show-more-btn"
            onClick={() => setShowAllMatch(p => !p)}
          >
            {showAllMatch ? "– less" : "+ more"}
          </button>
        )}
      </Section>

      <div style={{ padding: "12px 20px 20px" }}>
        <button
          className="apply-btn"
          onClick={applyFilters}
        >
          Apply Filters
        </button>
      </div>

    </div>
  );
}